class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.rangeMin = this.querySelector('input[type="range"]:first-child');
    this.rangeMax = this.querySelector('input[type="range"]:last-child');
    this.inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    this.inputMax = this.querySelector('input[name="filter.v.price.lte"]');

    this.inputMin.addEventListener("focus", this.inputMin.select);
    this.inputMax.addEventListener("focus", this.inputMax.select);
    this.inputMin.addEventListener("change", this.onInputMinChange.bind(this));
    this.inputMax.addEventListener("change", this.onInputMaxChange.bind(this));

    this.rangeMin.addEventListener("change", this.onRangeMinChange.bind(this));
    this.rangeMax.addEventListener("change", this.onRangeMaxChange.bind(this));
    this.rangeMin.addEventListener("input", this.onRangeMinInput.bind(this));
    this.rangeMax.addEventListener("input", this.onRangeMaxInput.bind(this));
  }

  onInputMinChange(event) {
    event.preventDefault();
    // READ PHASE — batch all reads before any writes
    const inputVal = parseInt(event.target.value);
    const maxVal = parseInt(this.inputMax.value || event.target.max);
    const minVal = parseInt(event.target.min);
    const rangeMax = parseInt(this.rangeMin.max);
    // WRITE PHASE
    const newVal = Math.max(Math.min(inputVal, maxVal - 1), minVal);
    event.target.value = newVal;
    this.rangeMin.value = newVal;
    this.rangeMin.parentElement.style.setProperty("--from", `${(newVal / rangeMax) * 100}%`);
  }

  onInputMaxChange(event) {
    event.preventDefault();
    // READ PHASE — batch all reads before any writes
    const inputVal = parseInt(event.target.value);
    const minVal = parseInt(this.inputMin.value || event.target.min);
    const maxLimit = parseInt(event.target.max);
    const rangeMax = parseInt(this.rangeMax.max);
    // WRITE PHASE
    const newVal = Math.min(Math.max(inputVal, minVal + 1), maxLimit);
    event.target.value = newVal;
    this.rangeMax.value = newVal;
    this.rangeMax.parentElement.style.setProperty("--to", `${(newVal / rangeMax) * 100}%`);
  }

  onRangeMinChange(event) {
    event.stopPropagation();
    this.inputMin.value = event.target.value;
    this.inputMin.dispatchEvent(new Event("change", { bubbles: true }));
  }

  onRangeMaxChange(event) {
    event.stopPropagation();
    this.inputMax.value = event.target.value;
    this.inputMax.dispatchEvent(new Event("change", { bubbles: true }));
  }

  onRangeMinInput(event) {
    event.target.value = Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1);
    event.target.parentElement.style.setProperty(
      "--from",
      `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
    );
    this.inputMin.value = event.target.value;
  }

  onRangeMaxInput(event) {
    event.target.value = Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1);
    event.target.parentElement.style.setProperty(
      "--to",
      `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
    );
    this.inputMax.value = event.target.value;
  }
}
customElements.define("price-range", PriceRange);
